import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router';
import { ArrowLeftIcon } from '@phosphor-icons/react';
import { useSuspenseQuery } from '@tanstack/react-query';
import { DashboardShare } from '@/components/dashboard-share';
import { PageContent } from '@/components/page-content';
import { PageHeader } from '@/components/page-header';
import { Button } from '@/components/ui/button';
import { useProjects } from '@/hooks/use-projects';
import { dashboardConfigOptions } from '@/hooks/query-options';
import { hasPermission } from '@/lib/permissions';

export const Route = createFileRoute('/_auth/_side-layout/dashboard-share')({
  component: DashboardSharePage,
  beforeLoad: async ({ context }) => {
    if (!hasPermission(context.userRole, { project: ['update'] })) {
      throw redirect({ to: '/' });
    }
  },
});

function DashboardSharePage() {
  const { projectId } = useProjects();
  const navigate = useNavigate();
  const { data: dashConfig } = useSuspenseQuery(
    dashboardConfigOptions({ projectId: projectId! }),
  );

  return (
    <>
      <PageHeader
        title="Public Dashboard"
        description="Share a live public view of your project metrics."
        actions={
          <Button
            variant="outline"
            iconLeft={<ArrowLeftIcon />}
            onClick={() => void navigate({ to: '/' })}
          >
            Back to Dashboard
          </Button>
        }
      />
      <PageContent>
        {/* Keyed on the share, so a newly generated link loads its defaults into the form. */}
        <DashboardShare
          key={dashConfig.open?.id ?? 'none'}
          data={dashConfig}
          projectId={projectId!}
        />
      </PageContent>
    </>
  );
}
